export default __webpack_public_path__ + "static/media/oncology.ce736137.jpg";